{{ value | title: options }}
